const scrollToTop = () => {
  let offset = 150;
  let progressWrap = document.querySelector('.progress-wrap');
  let progressPath = document.querySelector('.progress-wrap path');

  // If either element is not found, exit early
  if (!progressWrap || !progressPath) {
    console.warn('Scroll to top elements not found in the DOM');
    return;
  }

  let pathLength = progressPath.getTotalLength();
  
  const updateProgress = () => {
    let scroll = window.scrollY;
    let height = document.documentElement.scrollHeight - window.innerHeight;
    let progress = pathLength - (scroll * pathLength) / height;
    progressPath.style.strokeDashoffset = progress;
  };

  // Set up the progress path
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

  // Initial progress update
  updateProgress();

  // Add scroll event listeners
  window.addEventListener('scroll', updateProgress);
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > offset) {
      progressWrap.classList.add('active-progress');
    } else {
      progressWrap.classList.remove('active-progress');
    }
  });

  // Add click event listener
  progressWrap.addEventListener('click', function (event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return false;
  });
};

export default scrollToTop;
